module.exports = __webpack_public_path__ + "static/media/chef_01.c767a982.png";